import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({ breakpoints });

export const overrides = {
	'.accordionList': {
		width: '100%',
		marginTop: remCalc(50),
		marginBottom: remCalc(50),
		'&--flush': {
			marginTop: 0,
			marginBottom: 0,
		},
		'.accordionList__category': {
			'& + &': { marginTop: remCalc(50) },
		},
		'.accordionList__categoryTitle': {
			margin: `0 0 ${remCalc(40)}`,
			color: getColor('ivory', 700),
			textTransform: 'uppercase',
		},
		'.accordionList__item': {
			backgroundColor: 'transparent',
			'&::before': { display: 'none' },
			borderTop: `1px solid ${getColor('ivory', 500)}`,
			'&:last-of-type': { borderBottom: `1px solid ${getColor('ivory', 500)}` },
			'& .MuiAccordionSummary-expandIconWrapper': {
				transform: 'none',
				transition: 'none',
			},
			'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded .accordionList__icon': {
				transform: 'rotate(-90deg)',
			},
		},
		'.accordionList__trigger': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			gap: remCalc(20),
			minHeight: remCalc(72),
			cursor: 'pointer',
			transition: 'padding 120ms ease-out',
			padding: `${remCalc(40)} 0`,
			color: getColor('ivory', 700),
			'&.Mui-expanded': { paddingBottom: 0 },
			'&:focus-visible': {
				outline: `2px solid ${getColor('ivory', 400)}`,
				outlineOffset: remCalc(4),
			},
		},
		'.accordionList__icon': {
			position: 'relative',
			flex: `0 0 ${remCalc(18)}`,
			width: remCalc(18),
			height: remCalc(18),
			transition: 'transform var(--transition-duration) ease-in-out',
			transform: 'rotate(90deg)',
			'path': {
				fill: getColor('ivory', 600),
			},
		},
		'.accordionList__content': {
			padding: `0 ${remCalc(38)} ${remCalc(40)} 0 !important`,
			color: getColor('ivory', 600),
			'h2, h3, h4, h5, h6': { color: getColor('ivory', 700) },
			'& > :first-of-type': { marginTop: 0 },
			'& > :last-child': { marginBottom: 0 },
		},
		'@media (prefers-reduced-motion: reduce)': {
			'.MuiCollapse-root, .accordionList__trigger, .accordionList__icon, .accordionList__icon::after': {
				transition: 'none',
			},
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: remCalc(30),
			marginBottom: remCalc(30),
			'.accordionList__category + .accordionList__category': { marginTop: remCalc(30) },
			'.accordionList__trigger': { minHeight: remCalc(64), fontSize: remCalc(18) },
		},
	},
};

export default overrides;
